//Imports node_modules
import React, { useContext, useEffect, useState } from 'react'
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Geolocation from '@react-native-community/geolocation';
import moment from 'moment';
import Cookies from 'universal-cookie';

//Imports Css
import './ProductionPage.css'

//Import Components
import TopBar from '../../../components/Global/topBar/TopBar';

//Import Data
import { globalVariables } from '../../../data/GlobalVariables'
import { globalModals } from '../../../data/GlobalModals'
import { globalFunctions } from '../../../data/GlobalFunctions';

//Import images
import playImage from '../../../imgs/playsvgnew.svg';
import stopImage from '../../../imgs/stopsvgnew.svg';

//Pagina onde o cliente selciona a entidade
const ProductionPage = (props) => {

    //--- Variaveis

    //Variaveis Locais
    const {
        apiBaseUrl,
        pe,
        groupPe,
        zone,
        obra,
    } = useContext(globalVariables)


    const {
        advancedClick
    } = useContext(globalFunctions);

    const {
        ShowMessageModal,
        DismisLoadingModal,
        ShowLoadingModal,
        DismisMessageModal,
    } = useContext(globalModals);

    const navigate = useNavigate();

    const [eGrupo, setEGrupo] = useState(false);

    const [productionEnd, setProductionEnd] = useState(false);

    const [passedTimeText, setPassedTimeText] = useState("");

    const [passedTimeDateStart, setPassedTimeDateStart] = useState("");
    const [passedTimeDateEnd, setPassedTimeDateEnd] = useState("");
    const [passedDays, setPassedDays] = useState("");
    const [finalMembers, setFinalMembers] = useState([]);

    //Tbm pode ter o removeCookie 
    const cookies = new Cookies();

    const queryParams = new URLSearchParams(window.location.search);

    const [productionEndInfo, setProductionEndInfo] = useState(
        {
            datai: "",
            cct: "",
            horai: "",
            descricao: "",
            dataNow: "",
            horaNow: "",
        });

    //--- Fim variaveis 

    //--- Funções

    //----- Funções Top Bar  
    function nextBtnClick() {}

    function backbtnClick() {
        if (queryParams.get('auto')) {
            navigate('/userPage')
        } else {
            if (queryParams.get('newprod')) {
                navigate('/productionWorkListPage')
            } else {
                navigate('/zonePage?back=true')
            }
        }
    }

    //----- Fim Funções Top Bar  

    useEffect(() => {
        var url = ''

        if (pe !== 'empty') {
            setEGrupo(false);
            url = 'Zones/verefyUserInProduction?npe=' + pe.npe
        } else {
            setEGrupo(true)

            var localGroupStam = localStorage.getItem('grupostamp')

            if (localGroupStam === null || localGroupStam === undefined) {
                url = 'skip'
            } else {
                url = 'Zones/verefyGroupInProduction?groupStamp=' + localGroupStam
            }
        }

        //Verefica se já existe algum produção por funcionario
        if (url !== 'skip') {
            axios.post(apiBaseUrl + url, { timeout: 50000 }).then((response) => {
                if (response.data > 0) {
                    setProductionEnd(true);


                    var urlsecond = ''
                    if (pe !== 'empty') {
                        urlsecond = 'Production/showCurrentProduction?npe=' + pe.npe
                    } else {
                        urlsecond = 'Production/showCurrentProductionGroup?groupStamp=' + localStorage.getItem('grupostamp')
                    }

                    //---Second Call
                    axios.post(apiBaseUrl + urlsecond, { timeout: 50000 }).then((response) => {

                        if(pe !== 'empty'){
                            Object.keys(response.data).forEach(function (productionListItem, index) {
                                if (response.data[index].npei === pe.npe) {
                                    setProductionEndInfo(response.data[index]);
    
                                    const newStartDate = new Date(response.data[index].datai + "T" + response.data[index].horai);
                                    const newEndDate = new Date(response.data[index].dataNow + "T" + response.data[index].horaNow);
    
                                    setPassedTimeDateStart(newStartDate)
                                    setPassedTimeDateEnd(newEndDate)
    
                                    var finalMembers = []
                                    finalMembers.push(response.data[index])
    
                                    setFinalMembers(finalMembers);
                                }
                            });
                        }else{
                            setProductionEndInfo(response.data[0]);
    
                            //Calcula o tempo passado
                            const newStartDate = new Date(response.data[0].datai + "T" + response.data[0].horai);
                            const newEndDate = new Date(response.data[0].dataNow + "T" + response.data[0].horaNow);

                            setPassedTimeDateStart(newStartDate)
                            setPassedTimeDateEnd(newEndDate)

                            var finalMembers = []
                            Object.keys(response.data).forEach(function (productionListItem, index) {
                                finalMembers.push(response.data[index])
                            });

                            setFinalMembers(finalMembers);
                        }
                    }, (error) => {
                        ShowMessageModal(
                            {
                                modaltype: 'error',
                                modalTitle: 'Erro a ler as opções',
                                modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                                nextClick: 'dismiss',
                                nextBtnTxt: 'Compreendi',
                                crossClick: 'dismiss',
                            });
                    });

                    //---End Second Call
                }
            }, (error) => {
                ShowMessageModal(
                    {
                        modaltype: 'error',
                        modalTitle: 'Erro a ler as opções',
                        modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                        nextClick: 'dismiss',
                        nextBtnTxt: 'Compreendi',
                        crossClick: 'dismiss',
                    });
            });
        }

        // eslint-disable-next-line
    }, []);

    useEffect(() => {

        if (passedTimeDateEnd !== '' && passedTimeDateEnd !== undefined) {
            const interval = setInterval(() => updateDate(passedTimeDateEnd), 1000);
            return () => {
                clearInterval(interval);
            };
        }
        // eslint-disable-next-line
    }, [passedTimeDateEnd]);

    function updateDate(date) {
        setPassedTimeDateEnd(new Date(date.setSeconds(date.getSeconds() + 1)))
    }

    useEffect(() => {
        let daysDiff = moment(passedTimeDateEnd).diff(passedTimeDateStart, 'days')
        let hourDiff = moment(passedTimeDateEnd).diff(passedTimeDateStart, 'hours')
        let minDiff = moment(passedTimeDateEnd).diff(passedTimeDateStart, 'minutes')
        let secDiff = moment(passedTimeDateEnd).diff(passedTimeDateStart, 'seconds')

        setPassedDays(daysDiff);

        var passedTimeText =

            (hourDiff - (daysDiff * 24)).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            })
            + ":" +
            (minDiff - (hourDiff * 60)).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            })
            + ":" +
            (secDiff - (minDiff * 60)).toLocaleString('en-US', {
                minimumIntegerDigits: 2,
                useGrouping: false
            });
        setPassedTimeText(passedTimeText);

        // eslint-disable-next-line
    }, [passedTimeDateEnd]);

    //--- Fim funções

    //Para não dar erro no modal
    Modal.setAppElement('body');

    //Dá render á tabela de menbros casos seja uma produção em grupo 
    function renderTableMembers() {

        if (productionEnd) {
            //No futuro mostrar os elementos de grupo que iniçiarama a produção
            return (
                <div>
                    <div className="py-2 mt-1" style={{ marginLeft: '7px' }}>
                        <h3 className="font-size-15 font-weight-bold">Membros</h3>
                    </div>
                    <div className="table-responsive" style={{ margin: '0px 7px 0px 7px' }} >
                        <table className="table-nowrap table">
                            <thead>
                                <tr>
                                    <th style={{ width: '70px' }}>Nº.</th>
                                    <th>Nome</th>
                                </tr>
                            </thead>
                            <tbody>
                                {finalMembers.map((member, index) =>
                                    <tr key={member.npei}>
                                        <td>{member.npei}</td>
                                        <td>{member.nmpe}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )

        } else {
            if (eGrupo) {
                var groupMenbers = JSON.parse(localStorage.getItem('storedGroupMembers'))
                return (
                    <div>
                        <div className="py-2 mt-1" style={{ marginLeft: '7px' }}>
                            <h3 className="font-size-15 font-weight-bold">Membros</h3>
                        </div>
                        <div className="table-responsive" style={{ margin: '0px 7px 0px 7px' }}>
                            <table className="table-nowrap table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '70px' }}>Nº.</th>
                                        <th>Nome</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {groupMenbers.map((member, index) =>
                                        <tr key={member.npe}>
                                            <td>{member.npe}</td>
                                            <td>{member.nmpe}</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            }
            else {
                return (
                    <div>
                        <div className="py-2 mt-3">
                            <h3 className="font-size-15 font-weight-bold">Membros</h3>
                        </div>
                        <div className="table-responsive">
                            <table className="table-nowrap table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '70px' }}>Nº.</th>
                                        <th>Nome</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr key={pe.npe}>
                                        <td>{pe.npe}</td>
                                        <td>{pe.nmpe}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            }
        }
    }

    function startProduction() {
        DismisMessageModal();
        ShowLoadingModal();

        Geolocation.getCurrentPosition(info => {

            let finalCallObjject = {};

            finalCallObjject.cuStamp = obra.custamp;
            finalCallObjject.cttType = 0;
            finalCallObjject.nctt = zone.nctt;
            finalCallObjject.cct = obra.cct;
            finalCallObjject.location = info.coords.latitude + " " + info.coords.longitude;

            //Tenho de mandar o numero de todos os pe caso seja grupo
            finalCallObjject.singlePeNpe = pe.npe;
            finalCallObjject.groupPe = groupPe;
            var groupMenbers = JSON.parse(localStorage.getItem('storedGroupMembers'))
            finalCallObjject.groupPeMembers = JSON.stringify(groupMenbers);

            //Query para ler os funçionarios/grupos que o dispositivo tem acesso
            axios.post(apiBaseUrl + 'Production/startNewProduction', finalCallObjject, { timeout: 50000 }).then((responseStart) => {

                const isDataAvailable = responseStart.data !== undefined && responseStart.data !== "";
                if (isDataAvailable) {
                    const myJSON = JSON.stringify(responseStart.data);

                    if (myJSON.slice(0, 6) === '"Erro:') {
                        ShowMessageModal(
                            {
                                modaltype: 'warning',
                                modalTitle: 'Atenção!',
                                modalMessage: responseStart.data.substring(5),
                                nextClick: 'dismiss',
                                nextBtnTxt: 'Cooprendi',
                                crossClick: 'dismiss',
                                backClick: 'dismiss',
                            })
                    } else {

                        //Operação a executar
                        if (eGrupo) {
                            //Isto é para quando o utilizador reiniciar o pc ele não perder as cookies do grupo
                            var date = new Date();
                            date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));

                            localStorage.setItem('grupostamp', responseStart.data.stampGrupo);
                            localStorage.setItem('jorneystamp', responseStart.data.stampJorney);
                        }

                        DismisLoadingModal()
                        navigate('/userPage?success=true')
                    }
                } else {
                    ShowMessageModal(
                        {
                           dmodaltype: 'info',
                            modalTitle: 'Não foi possivel ler a reposta do servidor',
                            modalMessage: 'Por favor entre em contacto com o administrador'
                        });
                }
            }, (error) => {
                ShowMessageModal(
                    {
                        modaltype: 'error',
                        modalTitle: 'Erro a ler as opções',
                        modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                        nextClick: 'dismiss',
                        nextBtnTxt: 'Compreendi',
                        crossClick: 'dismiss',
                    });
            });
        }, (info => {
            DismisLoadingModal()
            ShowMessageModal(
                {
                    modaltype: 'error',
                    modalTitle: 'Erro na localização.',
                    modalMessage: 'Precisa de pertimitir acesso á sua localização.',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                });
        }
        ));
    }

    function endProduction() {
        DismisMessageModal();
        ShowLoadingModal();

        Geolocation.getCurrentPosition(info => {

            let finalCallObjject = {};

            finalCallObjject.nctt = zone.nctt;
            finalCallObjject.location = info.coords.latitude + " " + info.coords.longitude;

            //Tenho de mandar o numero de todos os pe caso seja grupo
            finalCallObjject.singlePeNpe = pe.npe;
            finalCallObjject.groupPe = groupPe;
            var groupMenbers = JSON.parse(localStorage.getItem('storedGroupMembers'))
            finalCallObjject.groupPeMembers = JSON.stringify(groupMenbers);

            if(pe !== 'empty'){
                finalCallObjject.groupStamp = 'none'
            }else{
                finalCallObjject.groupStamp = cookies.get('grupostamp')
            }

            //Query para ler os funçionarios/grupos que o dispositivo tem acesso
            axios.post(apiBaseUrl + 'Production/endProduction', finalCallObjject, { timeout: 50000 }).then((response) => {
                const isDataAvailable = response.data && response.data.length;
                if (isDataAvailable) {
                    const myJSON = JSON.stringify(response.data);
                    if (myJSON.slice(0, 6) === '"Erro:') {
                        ShowMessageModal(
                            {
                                modaltype: 'error',
                                modalTitle: 'Erro a ler as opções',
                                modalMessage: response.data,
                                nextClick: 'dismiss',
                                nextBtnTxt: 'Compreendi',
                                crossClick: 'dismiss',
                            })
                    } else {
                        //Operação a executar

                        //Só remove caso seja uma produção em grupo
                        if(pe === 'empty'){
                            localStorage.removeItem('grupostamp');
                        }
                        
                        DismisLoadingModal()
                        navigate('/userPage?success=true')
                    }
                } else {

                    ShowMessageModal(
                        {
                            modaltype: 'success',
                            modalTitle: 'Operação concluída!',
                            modalMessage: response.data,
                            nextClick: 'reset',
                            nextBtnTxt: 'Compreendi'
                        });
                }
            }, (error) => {
                ShowMessageModal(
                    {
                        modaltype: 'error',
                        modalTitle: 'Erro a ler as opções',
                        modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                        nextClick: 'dismiss',
                        nextBtnTxt: 'Compreendi',
                        crossClick: 'dismiss',
                    });
            });
        }, (info => {

            DismisLoadingModal()

            ShowMessageModal(
                {
                    modaltype: 'error',
                    modalTitle: 'Erro na localização.',
                    modalMessage: 'Precisa de pertimitir acesso á sua localização.',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                });
            }
        ));
    }

    function showMessageStart() {
        ShowMessageModal(
            {
                modaltype: 'info',
                modalTitle: 'Iniciar Produção',
                modalMessage: 'Deseja mesmo iniciar a produção nesta zona?',
                nextClick: function nextClick() { startProduction() },
                nextBtnTxt: 'Confirmar',
                crossClick: 'dismiss',
                backClick: 'dismiss',
            })
    }

    function showMessageEnd() {
        ShowMessageModal(
            {
                modaltype: 'info',
                modalTitle: 'Finalizar Produção',
                modalMessage: 'Deseja mesmo finalizar a produção nesta zona?',
                nextClick: function nextClick() { endProduction() },
                nextBtnTxt: 'Confirmar',
                crossClick: 'dismiss',
                backClick: 'dismiss',
            })
    }

    function renderProductionBtn() {
        if (productionEnd) {
            return (
                <div className="planreds">
                    <label className="planred basic-planred" htmlFor="basic"
                        onClick={e => advancedClick(e, (e => showMessageEnd()))}
                        onTouchStart={e => advancedClick(e, (e => showMessageEnd()))}
                        onTouchEnd={e => advancedClick(e, (e => showMessageEnd()))}
                        onMouseDown={e => advancedClick(e, (e => showMessageEnd()))}
                        onMouseUp={e => advancedClick(e, (e => showMessageEnd()))}
                    >
                        <div className="planred-content" >
                            <div className='row'>
                                <div className="col-sm-12">
                                    <div className="row d-flex" style={{ justifyContent: 'center', width: '100%', margin: '0px' }}>
                                        <div className="col-sm-6">
                                            <img loading="lazy" src={stopImage} alt="" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <h3 style={{ textAlign: 'center', width: '100%' }}><strong>Finalizar Produção</strong></h3>
                                </div>
                            </div>
                        </div>
                    </label>
                </div>
            )
        } else {
            return (

                <div className="plans">
                    <label className="plan basic-plan" htmlFor="basic"
                        onClick={e => advancedClick(e, (e => showMessageStart()))}
                        onTouchStart={e => advancedClick(e, (e => showMessageStart()))}
                        onTouchEnd={e => advancedClick(e, (e => showMessageStart()))}
                        onMouseDown={e => advancedClick(e, (e => showMessageStart()))}
                        onMouseUp={e => advancedClick(e, (e => showMessageStart()))}
                    >
                        <div className="plan-content">
                            <div className='row'>
                                <div className="col-sm-12">
                                    <div className="row d-flex" style={{ justifyContent: 'center', width: '100%', margin: '0px' }}>
                                        <div className="col-sm-6">
                                            <img loading="lazy" src={playImage} alt="" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <h3 style={{ textAlign: 'center', width: '100%' }}><strong>Iniciar Produção</strong></h3>
                                </div>
                            </div>
                        </div>
                    </label>
                </div>
            )
        }
    }

    function renderProdInformation() {
        if (productionEnd) {
            return (
                <div>
                    <div className='infoDisp'>
                        <div className="invoice-title">
                            <h3 style={{ margin: '0px' }} className="float-end font-size-18"><strong>{productionEndInfo.cct}</strong></h3>
                            <h3 style={{ margin: '3px 0px 0px 0px', fontSize: '18px' }} className="float-end font-size-16">{productionEndInfo.descricao}</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12" style={{ marginLeft: '7px' }}>
                            <address style={{ marginBottom: '0px' }}>
                                <span style={{ fontSize: '17px' }}><strong style={{ fontSize: '16px' }}>Zona:</strong> {zone.nctt + ' - ' + zone.nmctt}</span>
                                <br></br>
                                <span style={{ fontSize: '17px' }}><strong style={{ fontSize: '16px' }}>Data Inicio:</strong> {productionEndInfo.datai} {productionEndInfo.horai}</span>
                                <br></br>
                                <span style={{ fontSize: '17px' }}><strong style={{ fontSize: '16px' }}>Tempo passado:</strong> {passedTimeText}</span>
                                <br></br>
                                {passedDays > 0 ? <span style={{ fontSize: '17px' }}><strong style={{ fontSize: '16px' }}>Diferença de dias:</strong> {passedDays}</span> : false}
                            </address>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <div className='infoDisp'>
                        <div className="invoice-title">
                            <h3 style={{ margin: '0px' }} className="float-end font-size-18"><strong>{obra.cct}</strong></h3>
                            <h3 style={{ margin: '3px 0px 0px 0px', fontSize: '18px' }} className="float-end font-size-18">{obra.descricao}</h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12" style={{ marginLeft: '7px' }}>
                            <address style={{ marginBottom: '0px' }}>
                                <span style={{ fontSize: '17px' }}><strong style={{ fontSize: '16px' }}>Zona:</strong> {zone.nctt + ' - ' + zone.nmctt}</span>
                            </address>
                        </div>
                    </div>
                </div>
            )
        }
    }

    return (
        <div className="ProductionPage">
            <div className='topbar'>
                <TopBar texto='Informação Final' type='blue' backText='Voltar' nextBtnClick={nextBtnClick} backbtnClick={backbtnClick} layout='1'></TopBar>
            </div>
            <div className="pageContent">
                <div className="flexLayoutScrollable" style={{ marginTop: '54px' }}>
                    <div className="row" style={{ width: '100%' }}>
                        <div className="col-sm-6" >
                            <div>
                                <div className="card-body">
                                    <div>
                                        <div className="plansdefault" >
                                            <div className='width100'>
                                                {renderProdInformation()}
                                            </div>

                                            <div className='width100'>
                                                {renderTableMembers()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-6">
                            <div>
                                {renderProductionBtn()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ProductionPage